module.exports = __webpack_public_path__ + "img/share-yes.e7fcb34e.png";